import { SiteMasterListItemModel } from '../models';

export function createSiteMasterIndex(
  sites: SiteMasterListItemModel[],
): Map<number, SiteMasterListItemModel> {
  return new Map(sites.map((site) => [site.id, site]));
}

export function createSiteMasterCompanyIndex(
  sites: SiteMasterListItemModel[],
): Map<number, SiteMasterListItemModel> {
  return new Map(sites.map((site) => [site.companyId, site]));
}
